import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get, post } from "sr/utils/axios";

export const getUserFullProfile = async () => {
  try {
    return await get<ApiResponse<[]>>("/user").then((res) => {
      if (res?.success === true) {
        return res;
      } else {
        return null;
      }
    });
  } catch (e) {
    HandleApiError(e);
  }
};

export const switchUserType = async (userType: string) => {
  try {
    return await post<ApiResponse<any>>("/user/switch-user", { userType });
  } catch (e: any) {
    return e?.response?.data;
  }
};

export const registerTargetUserType = async (userType: string) => {
  try {
    return await post<ApiResponse<any>>("/user/register-target-type", {
      userType,
    });
  } catch (e: any) {
    return e?.response?.data;
  }
};
